import{ Api } from "../Api";
require('dotenv');
const axios = require('axios').default;

let AppUserApi =
{
    endpoint : "AppUser/",

    async get() {
        const URL = process.env.REACT_APP_API_ENDPOINT + this.endpoint

        const response = await axios.post(URL, {}, {withCredentials:true});
        return response.data;
    }
}

//Assign Api Mixin 
AppUserApi = Object.assign({}, Api, AppUserApi);

export { AppUserApi }